<template>
  <div>
    <div class="filter-inline-panel cle">
      <el-form :inline="true" size="mini" :model="filters" class="filter-panel"></el-form>
      <div class="list-opinion fr">
        <el-button type="primary" size="mini" @click="$router.back(-1)">{{$t('index.return')}}</el-button>
      </div>
    </div>
    <el-table :data="list" border size="mini">
      <el-table-column prop="transaction_id" align="center" :label="$t('sale_index.id')"></el-table-column>
      <el-table-column :prop="lang=='cn'?'theme_cn':'theme'" align="center" :label="$t('sale_index.subject')" data-name="主题"></el-table-column>
      <el-table-column prop="price" align="center" :label="$t('sale_index.price')" data-name="单价"></el-table-column>
      <el-table-column prop="num" align="center" :label="$t('sale_index.num')" data-name="学生数量"></el-table-column>
      <el-table-column prop="discounts" align="center" :label="$t('sale_index.discounts')" data-name="折扣"></el-table-column>
      <el-table-column prop="total" align="center" :label="$t('sale_index.total')" data-name="总价"></el-table-column>
      <!-- <el-table-column prop="role_id" align="center" label="角色" :formatter="role_id_f"></el-table-column> -->
    </el-table>
    <div class="page-pagination">
		<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
	data() {
		return {
			id:'',
			list: [],
			editFormVisible: false,
			filters: {},
			pages: {
				page: 1,
				count: 100,
				perpage: 20,
			},
		}
	},
	// 初始事件
	mounted: function () {
		this.id=this.$route.query.id;
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "salesRecord";
			var datas = {
				id:this_.id,
				page:this_.pages.page,
				num:this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count=res.sum;
			})
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 22px;
}
.page-pagination {
	padding: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/sale_record.vue